import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Loader2, Download, FileText } from "lucide-react";

export default function TenantDocuments() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/tenant/documents").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  if (rows === null) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;

  return (
    <div data-testid="tenant-documents">
      <h1 className="font-display text-2xl font-light mb-6">書類</h1>
      {rows.length === 0 ? (
        <div className="text-gray-500 text-sm py-10 text-center bg-[#161616] rounded-lg">共有された書類はまだありません。</div>
      ) : (
        <div className="space-y-2">
          {rows.map((d) => (
            <div key={d.id} className="bg-[#161616] border border-white/5 rounded-lg p-4 flex items-center gap-4" data-testid={`doc-row-${d.id}`}>
              <FileText className="w-5 h-5 text-brand shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="text-sm truncate">{d.title || d.filename}</div>
                <div className="text-xs text-gray-500">{(d.created_at || "").slice(0, 10)}</div>
              </div>
              <a href={`${API}/tenant/documents/${d.id}/download`} className="inline-flex items-center gap-1.5 text-sm text-gray-300 hover:text-white border border-white/10 rounded-md px-3 py-1.5" data-testid={`doc-download-${d.id}`}>
                <Download className="w-4 h-4" />ダウンロード
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
